import React, { createContext, useContext, useState, useCallback } from 'react';

const NotificationContext = createContext();

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within NotificationProvider');
  }
  return context;
};

export function NotificationProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((toast) => {
    const id = Date.now().toString();
    const newToast = {
      id,
      title: toast.title || 'Notification',
      message: toast.message || '',
      type: toast.type || 'info', // 'info' | 'success' | 'error' | 'warning'
      progress: toast.progress || 0,
      status: toast.status || 'pending', // 'pending' | 'running' | 'completed' | 'failed'
    };
    
    setToasts((prev) => [...prev, newToast]);
    return id;
  }, []);

  const updateToast = useCallback((id, updates) => {
    setToasts((prev) =>
      prev.map((toast) =>
        toast.id === id ? { ...toast, ...updates } : toast
      )
    );
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);

  const clearAll = useCallback(() => {
    setToasts([]);
  }, []);

  return (
    <NotificationContext.Provider
      value={{ addToast, updateToast, removeToast, clearAll, toasts }}
    >
      {children}
    </NotificationContext.Provider>
  );
}
